import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { NumberFormControl } from "../Web/NumberFormControl";
import { XColumnContainer, XColumnContainerColumn, XStackContainer } from "../../Containers";
import { LabelFormControl } from "../Web/LabelFormControl";
import { TextControlSize, TextControlStyle } from "../../Utilities/FormDesignConstants";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col1 = new XColumnContainerColumn();
    let col2 = new XColumnContainerColumn();
    col2.interControlSpacing = 20;

    container.add(col1);
    container.add(col2);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "Large Size";
    col1.add(label);

    let textField = new NumberFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    col1.add(textField);

    textField = new NumberFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.OUTLINE;
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col1.add(textField);

    textField = new NumberFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.SHADED;
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col1.add(textField);

    textField = new NumberFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";
    textField.style = TextControlStyle.UNDERLINED;
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col1.add(textField);

    label = new LabelFormControl();
    label.text = "Small Size";
    col2.add(label);

    textField = new NumberFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    textField.size = TextControlSize.SMALL;
    col2.add(textField);

    textField = new NumberFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.OUTLINE;
    textField.valueName = "value";
    textField.size = TextControlSize.SMALL;
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col2.add(textField);

    textField = new NumberFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.SHADED;
    textField.valueName = "value";
    textField.size = TextControlSize.SMALL;
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col2.add(textField);

    textField = new NumberFormControl();
    textField.label = "Text Field Label";
    textField.style = TextControlStyle.UNDERLINED;
    textField.valueName = "value";
    textField.size = TextControlSize.SMALL;
    textField.requiredOnAllOutcomes = false;
    textField.overrideStyle = true;
    col2.add(textField);

    return { form: ui };
}

function getUIForOneControl(): {
    form: FormConfiguration;
    control: NumberFormControl;
} {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    let control = new NumberFormControl();
    container.add(control);
    control.valueName = "value";

    ui.add(container);

    return { form: ui, control };
}

export const NumberBoxStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Number Box",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as NumberFormControl;
                if (ctf) {
                    ctf.hintText = "hint text";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Number Box",
        "With Hint",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as NumberFormControl;
                if (ctf) {
                    ctf.placeholderText = "placeholder text";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Number Box",
        "With Placeholder",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as NumberFormControl;
                if (ctf) {
                    ctf.requiredOnAllOutcomes = true;
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Number Box",
        "With Validation",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values["value"] = 200;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Number Box",
        "From Data",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values["value"] = 200;
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Number Box",
        "From Data",
    ),

    new StoryNode(
        () => {
            let conf = getUIForOneControl();
            conf.control.min = 500;

            let data = new ExecutionData();
            data.values["value"] = 200;
            return (
                <FormRuntime
                    form={conf.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Number Box",
        "Validation With Min",
    ),

    new StoryNode(
        () => {
            let conf = getUIForOneControl();
            conf.control.separator = true;
            let data = new ExecutionData();
            data.values["value"] = "123,456,789";
            return (
                <FormRuntime
                    form={conf.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Number Box",
        "Separators??? - FIX",
    ),

    new StoryNode(
        () => {
            let conf = getUIForOneControl();
            conf.control.allowDecimals = true;
            let data = new ExecutionData();
            data.values["value"] = 150.12;
            return (
                <FormRuntime
                    form={conf.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Number Box",
        "Decimals",
    ),
];
